import { Specialty } from '@/graphql/graphql';
import { useAppSelector } from '@/redux/hooks';
import { selectHomepage } from '@/redux/state/homepage';
import { selectLanguage } from '@/redux/state/language';
import { faScaleBalanced } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import moment from 'moment';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Col, Card, CardBody } from 'reactstrap';

const pickService_t_prefix = "pages.homePage.pickService";

export const ChosenSpecialtyCard = () => {
    const { t } = useTranslation();
    const { currentLanguage } = useAppSelector(selectLanguage)
    const { choices: { specialty } } = useAppSelector(selectHomepage);
    return (
        <Col>
            <Card
                className="chosen-cards"
                style={{
                    marginTop: 0,
                    textAlign: "center",
                    color: "white",
                }}
            >
                <CardBody style={{ padding: "0.6rem" }}>
                    <span>
                        <FontAwesomeIcon icon={faScaleBalanced} />{" "}
                        {t(`${pickService_t_prefix}.chosenSpecialty`)}
                    </span>
                    <h4
                        style={{ margin: 0, textTransform: "capitalize" }}
                        className="category-social"
                    >
                        <span>{specialty![currentLanguage]?.title}</span>
                    </h4>
                </CardBody>
            </Card>
        </Col>
    );
};
export const ChosenContactMethodCard = () => {
    const { t } = useTranslation();
    const {
        choices: { contactMethod },
    } = useAppSelector(selectHomepage);
    return (
        <Col>
            <Card
                className="chosen-cards"
                style={{
                    marginTop: 0,
                    textAlign: "center",
                    // borderRadius: 0,
                    color: "white",
                    // backgroundColor: "#f96332",
                }}
            >
                <CardBody style={{ padding: "0.6rem" }}>
                    <span>
                        {t(`${pickService_t_prefix}.chosenContactMethod`)}{" "}
                        <i className="now-ui-icons ui-2_chat-round"></i>
                    </span>
                    <h4
                        style={{ margin: 0, textTransform: "capitalize" }}
                        className="category-social"
                    >
                        <span>
                            {t(
                                `${pickService_t_prefix}.contactMethods.${contactMethod?.id}.name`
                            )}
                        </span>
                    </h4>
                </CardBody>
            </Card>
        </Col>
    );
};
export const ChosenBookingTimeCard = () => {
    const { t } = useTranslation();
    const { currentLanguage } = useAppSelector(selectLanguage)
    const {
        choices: { bookingTime },
    } = useAppSelector(selectHomepage);
    const dateMoment = moment(bookingTime).locale(currentLanguage)
    return (
        <Col>
            <Card
                className="chosen-cards"
                style={{
                    marginTop: 0,
                    textAlign: "center",
                    color: "white",
                }}
            >
                <CardBody style={{ padding: "0.6rem" }}>
                    <span>
                        {t(`${pickService_t_prefix}.chosenBookingTime`)}{" "}
                        <i className="now-ui-icons ui-1_calendar-60"></i>
                    </span>
                    <h4
                        style={{ margin: 0, textTransform: "capitalize" }}
                        className="category-social"
                    >
                        <span>
                            {dateMoment.format("hA, dddd Do MMMM YYYY")}
                        </span>
                    </h4>
                </CardBody>
            </Card>
        </Col>
    );
};